import { isMorningClockTime } from "./AttendanceUtils";

const _graveyardLogStatus = (log, nextLog) => {
  const hasTimePmIn = log?.timePmIn && log?.timePmIn !== "--:--";
  // Do not treat log.timeOut as "in" when it's a morning time — biometrics often misfile
  const hasIn =
    hasTimePmIn ||
    (log?.timeOut &&
      log.timeOut !== "--:--" &&
      !isMorningClockTime(log.timeOut));

  const timePmOut = log?.timeOut && log.timeOut !== "--:--";
  const nextDayAmOut = nextLog?.timeAmOut && nextLog?.timeAmOut !== "--:--" ? true : false;
  // When PM in is missing but timeOut is morning on this row, that punch is the shift end, not "in"
  // const sameRowMorningOutMisfiledAsTimeOut =
  //   !hasTimePmIn &&
  //   timePmOut &&
  //   isMorningClockTime(log.timeOut);

  let hasOut = false;
  if (!hasTimePmIn) {
    hasOut = nextDayAmOut ;
  } else {
    hasOut = nextDayAmOut || timePmOut;
  }

  return {
    hasIn,
    hasOut: hasOut,
    noIn: !hasIn,
    noOut: !hasOut,
  };
};

const hasValidTimeIn = (log, isGraveyard) => {
  if (isGraveyard) {
    return (log?.timePmIn && log.timePmIn !== "--:--") || 
           (log?.timeIn && log.timeIn !== "--:--");
  }
  return (log?.timeIn && log.timeIn !== "--:--") || 
         (log?.timePmIn && log.timePmIn !== "--:--");
};

const hasValidTimeOut = (log, isGraveyard) => {
  if (isGraveyard) {
    return (log?.timeAmOut && log.timeAmOut !== "--:--") || 
           (log?.timeOut && log.timeOut !== "--:--");
  }
  return (log?.timeOut && log.timeOut !== "--:--") || 
         (log?.timeAmOut && log.timeAmOut !== "--:--");
};

export const _isAbsent = (log, isGraveyard, absentRules, totalLateUTMins, late, undertime, nextLog) => {
  let hasIn, hasOut, noIn, noOut;
  if (isGraveyard) {
    const status = _graveyardLogStatus(log, nextLog);
    hasIn = status.hasIn;
    hasOut = status.hasOut;
    noIn = status.noIn;
    noOut = status.noOut;
  } else {
    hasIn = hasValidTimeIn(log, isGraveyard);
    hasOut = hasValidTimeOut(log, isGraveyard);
    noIn = !hasIn;
    noOut = !hasOut;
  }

  // Common rule: if no time in and no time out, tag as absent (applies to all rules)
  if (noIn && noOut) {
    return true;
  }

  if (absentRules.isBasic) {
    if (
      (hasIn && noOut && late > 180) ||
      (hasOut && noIn && undertime > 120) ||
      totalLateUTMins > 240 
    ) return true;
  }
  if (absentRules.isAP) {
    if (
      late > 61 ||
      undertime > 61 ||
      totalLateUTMins > 60 ||
      (hasIn && noOut) ||
      (noIn && hasOut)
    ) return true;
  }
  if (absentRules.isJO) {
    if (
      (noIn && hasOut) ||
      (hasIn && noOut)
    ) return true;
  }

  return false;
};

export const _isHalfDay = (log, isGraveyard, payrollWithHalfDay, late, undertime, nextLog) => {
  if (!payrollWithHalfDay) {
    return false;
  }

  let hasIn, hasOut, noIn, noOut;
  if (isGraveyard) {
    const status = _graveyardLogStatus(log, nextLog);
    hasIn = status.hasIn;
    hasOut = status.hasOut;
    noIn = status.noIn;
    noOut = status.noOut;
  } else {
    hasIn = hasValidTimeIn(log, isGraveyard);
    hasOut = hasValidTimeOut(log, isGraveyard);
    noIn = !hasIn;
    noOut = !hasOut;
  }

  if ((hasIn && noOut  && late <= 180) || 
      (hasOut && noIn  && undertime <= 120)) {
    return true;
  }
  
  return false;
};

export const getAPBracketedMinutes = (totalLateUTMins) => {
  if (totalLateUTMins > 60) return 0; 
  if (totalLateUTMins > 45) return 60;
  if (totalLateUTMins > 30) return 45;
  if (totalLateUTMins > 15) return 30;
  if (totalLateUTMins > 0) return 15;
  return 0;
};
